'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.day;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/day.js
// module id = 658
// module chunks = 0